import { Mutation } from 'react-apollo'
import login, { Login, LoginInput } from '../../graphql/mutations/login'
import withMutation from './withMutation'

class LoginMutation extends Mutation<Login, LoginInput> {}

export default withMutation(login)(LoginMutation)



// WEBPACK FOOTER //
// ./src/components/mutations/LoginMutation.tsx